import { withController} from 'react-scroll-parallax';

const ImageContainer = withController( ({src, parallaxController }) => (
  <img
    src={src}
    alt=""
    onLoad={() => parallaxController.update()} 
  />
))

export default ImageContainer;